import React, { useEffect, useState } from "react";
import { apiClient } from "@/lib/auth";

export const inputCls = "w-full bg-navy-950 border border-slate-700 rounded-md px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:border-brand-cyan transition-colors";

export const initialValues = (fields) =>
  Object.fromEntries(fields.filter((f) => !f.archived).map((f) => [f.key, f.default ?? (f.type === "boolean" ? false : "")]));

function ProjectSelect({ value, onChange, testId }) {
  const [projects, setProjects] = useState([]);
  useEffect(() => { apiClient.get("/admin/billing/projects").then(({ data }) => setProjects(data.projects || [])).catch(() => {}); }, []);
  return (
    <select className={inputCls} value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testId}>
      <option value="">No project</option>
      {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
    </select>
  );
}

function Input({ f, value, onChange, testId }) {
  const common = { className: inputCls, value: value ?? "", onChange: (e) => onChange(e.target.value), "data-testid": testId };
  switch (f.type) {
    case "textarea": return <textarea rows={3} {...common} />;
    case "number": return <input type="number" step="any" {...common} />;
    case "money": return <div className="relative"><span className="absolute left-3 top-2 text-slate-500 text-sm">$</span><input type="number" step="0.01" min="0" {...common} className={`${inputCls} pl-6`} /></div>;
    case "date": return <input type="date" {...common} />;
    case "email": return <input type="email" {...common} />;
    case "phone": return <input type="tel" {...common} />;
    case "select": return (
      <select {...common}>
        {!f.required && <option value="">—</option>}
        {f.required && !value && <option value="">Choose…</option>}
        {(f.options || []).map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
    case "boolean": return (
      <label className="inline-flex items-center gap-2 text-sm text-slate-300 cursor-pointer">
        <input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} data-testid={testId} className="accent-cyan-400 w-4 h-4" /> Yes
      </label>
    );
    case "project": return <ProjectSelect value={value} onChange={onChange} testId={testId} />;
    default: return <input type="text" {...common} />;
  }
}

// Schema-driven form body — used by every quick-entry popup.
export default function FormRenderer({ form, values, setValues, prefix }) {
  const fields = form.fields.filter((f) => !f.archived && !f.hidden);
  return (
    <div className="space-y-3">
      {fields.map((f) => (
        <label key={f.key} className="block">
          <span className="block font-mono text-[0.6rem] tracking-[0.16em] uppercase text-slate-400 mb-1">
            {f.label}{f.required && <span className="text-rose-400"> *</span>}
          </span>
          <Input f={f} value={values[f.key]} onChange={(v) => setValues((s) => ({ ...s, [f.key]: v }))} testId={`${prefix}-field-${f.key}`} />
          {f.help && <span className="block mt-1 text-[0.7rem] text-slate-500">{f.help}</span>}
        </label>
      ))}
    </div>
  );
}
